import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetClinicPartnerPatientsArgs } from "../schemas/dashboard";

export const GET_CLINIC_PARTNER_PATIENTS_QUERY_KEY = "getClinicPartnerPatients";

const getClinicPartnerPatientsQueryKey = (args: GetClinicPartnerPatientsArgs) =>
  [GET_CLINIC_PARTNER_PATIENTS_QUERY_KEY, args.params] as const;

export const useGetClinicPartnerPatients = (args: GetClinicPartnerPatientsArgs) => {
  const client = useApiClient();

  return useQuery({
    queryKey: getClinicPartnerPatientsQueryKey(args),
    queryFn: () => client.getClinicPartnerPatients(args),
    keepPreviousData: true,
  });
};
